module.exports = __webpack_public_path__ + "static/price_btn01-10ec047764b8a963d9bf3144316bce5f.png";